import React, { useContext, useEffect } from "react";
import "./cardbody.css";
import moment from "moment";
import { StoreContext } from "../../../../../store/Provider";
import { basename } from "../../../../../config";

function ShipmentsCard(props) {
  const context = useContext(StoreContext);
  // Log props and massData for debugging

  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + "..";
    }
    return text;
  };

  useEffect(() => {
    console.log("context.co2ShipmentID:", context.co2ShipmentID);
    console.log("context.massData:", context.massData);
  }, [context.co2ShipmentID, context.massData]);

  // Destructure props to avoid accessing undefined properties directly
  const { shipmentList, status, mass } = props;
  console.log("mass222", mass);
  // console.log("props:", { mass, shipmentList, status });
  // useEffect(() => {
  //   console.log('props', props); // Log the entire props object for debugging
  //   console.log('mass', mass); // Log the mass object for debugging
  //   if (mass) {
  //     console.log('mass amount', mass.amount);
  //   }
  // }, [mass, props]);

  if (!shipmentList) {
    // Handle case where shipmentList is null or undefined
    return null; // Or return an error message or loading indicator
  }

  const renderMassData = (amount, unit) => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <span style={{ fontSize: "14px", fontWeight: "600" }}>
          {amount} {unit}
        </span>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginLeft: "5px",
          }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/Assets/Images/leaf_16.png`}
            alt="leaf"
          />
          <span
            style={{
              fontSize: "8px",
              fontWeight: "600",
              margin: 0,
              padding: 0,
              marginTop: -2,
            }}
          >
            CO<sub>2</sub>
          </span>
        </div>
      </div>
    );
  };

  return (
    <>
      <div
        className={`cardBodyParent pointer ${
          context.shipmentId === shipmentList.ShipmentId ? "selected" : ""
        }`}
        onClick={() => {
          context.setShipmentId(shipmentList.ShipmentId);
          context.setco2ShipmentID(shipmentList.ShipmentId);
          context.setMblNum(shipmentList.ShipmentId);
        }}
      >
        <div className="row cardBody co2 mx-0">
          <div className="col-3" style={{ width: "30%" }}>
            {/* <p>mass: {shipmentList.amount}</p>  */}
            <p
              className="shpId"
              title={shipmentList.ShipmentId}
              // style={{ display: "flex", justifyContent: "space-between" }}
            >
              {shipmentList.ShipmentId}

              {shipmentList.amount &&
                shipmentList.unit &&
                renderMassData(shipmentList.amount, shipmentList.unit)}
            </p>
            <p className="data" title={shipmentList.ConsigneeName}>
              {shipmentList.ConsigneeName}
            </p>
          </div>
          <div className="col-2" style={{ width: "17%" }}>
            <div className="shpstatus">
              <span>ETD</span>
            </div>
            <p
              className="data"
              title={moment(shipmentList.ETD).format("MM/DD/YYYY")}
            >
              {moment(shipmentList.ETD).format("MM/DD/YYYY")}
            </p>
          </div>
          <div className="col-2" style={{ width: "17%" }}>
            <div className="shpstatus">
              <span>ETA</span>
              <div
                className={
                  status === "On Time"
                    ? "ontime"
                    : status === "Delayed"
                    ? "delayed"
                    : null
                }
              >
                {status === "On Time"
                  ? "On Time"
                  : status === "Delayed"
                  ? "Delayed"
                  : null}
              </div>
            </div>
            <p
              className="data"
              title={moment(shipmentList.ETA).format("MM/DD/YYYY")}
            >
              {moment(shipmentList.ETA).format("MM/DD/YYYY")}
            </p>
          </div>
          <div className="col-5">
            <div className="shptimelinebody">
              <span>ORIGIN</span>
              <div className="shptimelinecontainer">
                <span>
                  <img
                    src={`/${basename}/Assets/Images/PlaceDot.svg`}
                    alt="placeDot"
                  />
                </span>
                <span>
                  <img
                    className="shptimelinemode"
                    src={
                      shipmentList.TransportMode === "SEA"
                        ? `/${basename}/Assets/Images/Ship.svg`
                        : shipmentList.TransportMode === "AIR"
                        ? `/${basename}/Assets/Images/Airplane.svg`
                        : null
                    }
                    alt="Ship"
                  />
                </span>
                <span>
                  <img
                    src={`/${basename}/Assets/Images/PlaceDot.svg`}
                    alt="placeDot"
                  />
                </span>
                <img
                  className="dottedline"
                  src={`/${basename}/Assets/Images/Line.svg`}
                  alt="line"
                />
              </div>
              <span>DESTINATION</span>
            </div>
            <p>
              <span title={shipmentList.OriginPortName}>
                {shipmentList.OriginPortName}
              </span>
              <span title={shipmentList.DestinationPortName}>
                {shipmentList.DestinationPortName}
              </span>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default ShipmentsCard;
